/* ChatHistorySkeleton.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U5zaO%7Bpadding-block%3Avar(--ds-space-200%2C1pc)%7D");
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { LoadingSkeleton } from '@townsquare/loading-skeleton';
const styles = {
  container: "_4c065U5zaO"
};
export const ChatHistorySkeleton = (): React.ReactNode => {
  return <Stack space="space.150" alignInline="center" alignBlock="center" grow="fill" xcss={styles.container} role="listitem">
			<LoadingSkeleton height="40px" />
			<LoadingSkeleton height="40px" />
			<LoadingSkeleton height="40px" />
		</Stack>;
};